<template>
  <div class="header">
    <a-row v-if="isPage('apps')">
      <a-col :span="5" @click="toAppall">
        <a-icon type="menu" style="font-size: 16px;margin-right: 2px;"/>
        全部事项
      </a-col>
      <a-col :span="16">
        <p class="logo1" v-if="!search_show" style="font-size: 15px">师生网上办事服务大厅</p>
        <a-input-search v-model="SearchAll" v-if="search_show" style="width: 100%;" placeholder="搜索事项名"
                        @search="onSearch"/>
      </a-col>
      <a-col :span="3">
        <a-icon style="font-size: 20px;" v-if="!search_show" @click="showSearch" type="search"/>
        <a href="javascript:;" @click="showSearch" v-if="search_show">取消</a>
      </a-col>
    </a-row>
    <a-row v-if="isPage('appall')">
      <a-col :span="3">
        <a-icon type="left" @click="toBack" style="font-size: 20px"/>
      </a-col>
      <a-col :span="16">
        <p class="logo1" v-if="!search_show" style="font-size: 16px">全部事项</p>
        <a-input-search v-model="SearchAll" v-if="search_show" placeholder="搜索事项名" style="width: 100%"
                        @search="onSearch"/>
      </a-col>
      <a-col :span="3">
        <a-icon style="font-size: 20px" v-if="!search_show" @click="showSearch" type="search"/>
        <a href="javascript:;" @click="showSearch" v-if="search_show">取消</a></a-col>
      <a-col :span="1"></a-col>
    </a-row>
    <a-row v-if="isPage('about')">
      <a-col :span="2">
        <a-icon type="left" @click="toBack" style="font-size: 20px"/>
      </a-col>
      <a-col :span="20">
        <p class="logo1" v-if="!search_show" style="font-size: 16px">我</p>
      </a-col>
      <a-col :span="2"></a-col>
    </a-row>
    <a-row v-if="isPage('todo') || isPage('doing') || isPage('done') || isPage('flow_cc')|| isPage('apply')">
      <a-col :span="2">
        <a-icon type="left" @click="toBack('index')" style="font-size: 20px"/>
      </a-col>
      <a-col :span="20">
        <p style="font-size: 16px">我的事项</p>
      </a-col>
      <a-col :span="2"></a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "",
  inject: ["isPage", "reload"],
  data() {
    return {
      SearchAll: "",
      search_show: false,
    };
  },
  watch: {
    page_name: {
      handler(val, oldval) {
        if (val != oldval) {
          this.SearchAll = null;
          this.search_show = false;
          if (val === 'appall' && this.$store.getters.getState.appQuery.seq) {
            this.SearchAll = this.$store.getters.getState.appQuery.seq;
            this.search_show = true;
          }
        }
      }
    }
  },
  methods: {
    onSearch() {
      var val = this.SearchAll;
      if (!this.isPage("todo") && !this.isPage("apps") && !this.isPage("appall")) {
        this.$store.dispatch("SearchQ", {
          key: this.$route.name,
          property: "keyword",
          val
        })
      }
      if (this.isPage("apps")) {
        val = val ? val : "all";
        this.$store.dispatch("updateQuery", {seq: val});
        this.$router.push("/workflow/appall");
      }
      if (this.isPage("appall")) {
        val = val ? val : "all";
        this.$store.dispatch("updateQuery", {seq: val});
      }
      if (this.isPage("todo")) {
        this.$store.state.apiMap[this.$route.name].query = val;
      }
    },
    signOutOidc() {
      this.$store.dispatch("oidcStore/signOutOidc");
    },
    showSearch() {
      this.search_show = !this.search_show;
      if (!this.search_now) {
        this.$store.dispatch("updateQuery", {seq: "all", tag: "all"});
      }
    },
    toAppall() {
      this.$router.push("/workflow/appall");
    },
    toBack(val) {
      if (val) {
        this.$router.push("/workflow/index");
      } else {
        this.$router.back();
      }
    },
  },
  computed: {
    page_name() {
      return this.$route.name;
    },
    doing_num() {
      return this.$store.getters.getState.dataLength.medoing;
    },
    ccs_num() {
      return this.$store.getters.getState.dataLength.cc;
    },
    todo_num() {
      return this.$store.getters.getState.dataLength.todo;
    }
  }
};
</script>

<style>
.mobile .header {
  background: var(--now);
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  line-height: 35px;
  padding: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/wechat/layout/header.vue